import { AxiosInstance } from 'axios';
import { GetAddonsResponse, GetAllJurisdictionsResponse, GetConfigsResponse, GetFeesResponse, GetSummaryResponse, IAllConfigs, ServiceBaseConfig, UpdateAddonsPayload, UpdateColorPayload, UpdateFeePayload, UpdateJurisdictionPayload } from './Interfaces/IAccountService';

export class InstancesServices {
  public static async getConfigInstance(api: AxiosInstance): Promise<any> {
    const { data } = await api.get('/instances');

    return data;
  }

  public static async getFees(
    api: AxiosInstance,
    // payload: GetSummaryPayload,
    config: ServiceBaseConfig
  ): Promise<GetFeesResponse[]> {
    const response = await api.get('/instances/fees', config);

    return response.data.data.data;
  }

  public static async updateFee(
    api: AxiosInstance,
    payload: UpdateFeePayload,
    config: ServiceBaseConfig
  ): Promise<GetSummaryResponse> {
    const { data } = await api.post('/instances/fees', payload, config);

    return data;
  }

  public static async getAddons(
    api: AxiosInstance,
    // payload: GetSummaryPayload,
    config: ServiceBaseConfig
  ): Promise<GetAddonsResponse[]> {
    const response = await api.get('/instances/addons', config);

    return response.data.data.data;
  }

  public static async updateAddons(
    api: AxiosInstance,
    payload: UpdateAddonsPayload[],
    config: ServiceBaseConfig
  ): Promise<GetAddonsResponse> {
    const { data } = await api.post('/instances/addons', { addons: payload }, config);

    return data;
  }

  public static async getConfigs(
    api: AxiosInstance,
    config: ServiceBaseConfig
  ): Promise<IAllConfigs> {
    const response = await api.get('/instances/configs', config);

    return response.data.data;
  }

  public static async updateConfig(
    api: AxiosInstance,
    payload: IAllConfigs,
    config: ServiceBaseConfig
  ): Promise<GetConfigsResponse> {
    const { data } = await api.post('/instances/configs', payload, config);

    return data;
  }

  public static async getAllJurisdictions(
    api: AxiosInstance,
    config: ServiceBaseConfig
  ): Promise<GetAllJurisdictionsResponse> {
    const { data } = await api.get('/instances/jurisdictions', config);

    return data;
  }

  public static async updateJuridiction(
    api: AxiosInstance,
    payload: UpdateJurisdictionPayload,
    config: ServiceBaseConfig
  ): Promise<GetSummaryResponse> {
    const { data } = await api.post('/instances/jurisdictions', payload, config);

    return data;
  }

  public static async updateColors(
    api: AxiosInstance,
    payload: UpdateColorPayload[],
    config: ServiceBaseConfig
  ): Promise<any> {
    const { data } = await api.post('/instances/colors', {colors: payload}, config);

    return data;
  }

  public static async uploadLogo(
    api: AxiosInstance,
    file: File,
    config: ServiceBaseConfig
  ): Promise<UpdateColorPayload> {
    const formData = new FormData();
    formData.append('logo_file', file);

    const response = await api.post('/instances/logos', formData, config);

    return response.data;
  }
}
